var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundBlob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "background-blob",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1920 1080",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    "project-id": "1d1f71b415fa49758e4da7b514b20e47",
    "export-id": "a4e89e7c35b54b82a08f8d57da6d94ad",
    cached: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "background-blob-s-path1",
    d: "M1610.418246,0c-527.110684,0-576.204326,488.841655-379.829758,659.377464C1447.634064,853.168157,1830.047697,760.447083,1920,561.19018L1920,0h-309.581754Z",
    transform: "matrix(1 0 0 0.888154 0 0)",
    fill: "#fec828",
    fillOpacity: 0.2,
    stroke: "#3f5787",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundBlob);
export default __webpack_public_path__ + "static/media/background-blob.34dff0859543f8c5575b2c3fa52f4770.svg";
export { ForwardRef as ReactComponent };